<template>
  <div class="map-container">
    <GisMap ref="gisMap" @feature-selected="handleFeatureSelected" @clear-vector-layer="handleClearVectorLayer" />
    <div class="scaled-components" :style="containerStyle">
      <LegengMap ref="legengMap" z-index="1000" @layer-click="handleLayerClick"
        @selected-id-change="handleSelectedIdChange" />
      <InfoMap ref="infoMap" @close-overlay="handleCloseOverlay" @water-control="handleWaterControl" />
      <BottomMap ref="bottomMap" @layer-change="handleLayerChange" @show-legend="handleShowLegend"
        @positioning="handlePositioning" @query-search="handleQuerySearch" @clear-layer="handleClearLayer"
        @tool-click="handleToolClick" @location-map="handleLocationMap" @filter-change="handleFilterChange"
        @display-valve="handleDisplayValve" @cancel-display-valve="handleCancelDisplayValve"
        @show-affected-users="handleShowAffectedUsers" @clear-all-layers="handleClearAllLayers"
        @update-selected-valves="handleUpdateSelectedValves" @water-event-toggle="handleWaterEventToggle" />
      <WaterEvent ref="waterEvent" :visible="waterEventVisible" @close="handleWaterEventClose"
        @event-click="handleEventClick" />
      <AffectedUsers ref="affectedUsers" />
      <Scalebar />
      <ToolContainer :visible="toolContainerVisible" :tool-list="currentToolList" :active-tool-type="activeToolType"
        @tool-item-click="handleToolItemClick" @delete-tool="handleDeleteTool" />
    </div>
  </div>
</template>


<script>
import GisMap from './waterOCMapModule/gisMap.vue'
import LegengMap from './waterOCMapModule/legengMap.vue'
import InfoMap from './waterOCMapModule/infoMap.vue'
import BottomMap from './waterOCMapModule/bottomMap.vue'
import WaterEvent from './waterOCMapModule/WaterEvent.vue'
import AffectedUsers from './AffectedUsers.vue'
import Scalebar from './mapModule/Scalebar.vue'
import ToolContainer from './mapModule/ToolContainer.vue'

export default {
  name: 'BigMap',
  components: {
    GisMap,
    LegengMap,
    InfoMap,
    BottomMap,
    WaterEvent,
    AffectedUsers,
    Scalebar,
    ToolContainer
  },
  data () {
    return {
      interconnectionValveUrl: '/pipe-network/gis/pipe-networks/influence/work',
      listFindAppendageUrl: '/pipe-network/gis/pipe-networks/list-find-appendage',
      waterEventVisible: false, // 停水事件显示状态
      // 屏幕适配相关数据
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      scaleRatio: 1,
      // 基准屏幕尺寸（设计稿尺寸）
      baseWidth: 1920,
      baseHeight: 1080,
      // 最小和最大缩放比例
      minScale: 0.5,
      maxScale: 2.0,
      // 工具容器相关数据
      toolContainerVisible: false,
      currentToolList: [],
      activeToolType: null,
      toolContainerTimer: null // 工具容器监听定时器
    };
  },
  computed: {
    // 计算容器样式，包含缩放变换
    containerStyle () {
      return {
        transform: `scale(${this.scaleRatio})`,
        transformOrigin: 'top left',
        width: `${100 / this.scaleRatio}%`,
        height: `${100 / this.scaleRatio}%`
      };
    }
  },
  mounted () {
    this.initScreenAdaptation();
    this.bindResizeEvent();
    // 监听工具容器状态变化
    this.watchToolContainer();
  },
  beforeDestroy () {
    this.unbindResizeEvent();
    // 清除工具容器监听
    if (this.toolContainerTimer) {
      clearInterval(this.toolContainerTimer);
    }
  },
  methods: {
    // 初始化屏幕适配
    initScreenAdaptation () {
      this.updateScreenSize();
      this.calculateScaleRatio();
    },

    // 更新屏幕尺寸
    updateScreenSize () {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },

    // 计算缩放比例
    calculateScaleRatio () {
      // 计算宽高比
      const widthRatio = this.screenWidth / this.baseWidth;
      const heightRatio = this.screenHeight / this.baseHeight;

      // 使用较小的比例确保内容完全显示
      let ratio = Math.min(widthRatio, heightRatio);

      // 限制在最小和最大缩放比例之间
      ratio = Math.max(this.minScale, Math.min(this.maxScale, ratio));

      this.scaleRatio = ratio;

      console.log('屏幕适配信息:', {
        screenSize: `${this.screenWidth}x${this.screenHeight}`,
        baseSize: `${this.baseWidth}x${this.baseHeight}`,
        scaleRatio: this.scaleRatio
      });
    },

    // 绑定窗口大小变化事件
    bindResizeEvent () {
      this.handleResize = this.debounce(() => {
        this.updateScreenSize();
        this.calculateScaleRatio();
      }, 100);

      window.addEventListener('resize', this.handleResize);
    },

    // 解绑窗口大小变化事件
    unbindResizeEvent () {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    },

    // 防抖函数
    debounce (func, wait) {
      let timeout;
      return function executedFunction (...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    handleLayerClick (item, index, selected) {
      console.log('图层点击:', item, index, selected)

      // 直接调用 GisMap 的方法
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerSelected) {
        this.$refs.gisMap.handleLayerSelected(item);
      }
    },

    handleSelectedIdChange (data) {
      console.log('selectedID 变化:', data)

      // 将 selectedID 传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleSelectedIdChange) {
        this.$refs.gisMap.handleSelectedIdChange(data);
      }
    },

    handleFeatureSelected (feature) {
      console.log('要素选择事件:', feature)

      // 将要素数据传递给 InfoMap
      if (this.$refs.infoMap && this.$refs.infoMap.handleFeatureData) {
        this.$refs.infoMap.handleFeatureData(feature);
      }
    },

    handleLayerChange (data) {
      console.log('图层变化:', data)

      // 将图层数据传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleLayerChange) {
        this.$refs.gisMap.handleLayerChange(data);
      }
    },
    handleShowLegend () {
      console.log('图例变化')

      if (this.$refs.legengMap && this.$refs.legengMap.handleShowLegend) {
        this.$refs.legengMap.handleShowLegend();
      }
    },

    handleCloseOverlay () {
      console.log('接收到关闭覆盖层事件')

      // 调用 GisMap 的关闭覆盖层方法
      if (this.$refs.gisMap && this.$refs.gisMap.handleCloseOverlay) {
        this.$refs.gisMap.handleCloseOverlay();
      }
    },

    handlePositioning () {
      console.log('接收到定位事件')

      // 调用 GisMap 的定位方法
      if (this.$refs.gisMap && this.$refs.gisMap.handlePositioning) {
        this.$refs.gisMap.handlePositioning();
      }
    },
    handleQuerySearch (queryParams) {
      console.log('接收到查询事件:', queryParams)

      // 将查询事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleQuerySearch) {
        this.$refs.gisMap.handleQuerySearch(queryParams);
      }
    },

    handleClearLayer (layerId) {
      console.log('接收到清除图层事件:', layerId);

      // 将清除图层事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.clearLayerById) {
        this.$refs.gisMap.clearLayerById(layerId);
      }
    },

    handleClearVectorLayer () {
      console.log('接收到清除矢量图层事件');

      // 通知 InfoMap 隐藏详情面板
      if (this.$refs.infoMap) {
        this.$refs.infoMap.contentInfoShow = false;
      }
    },

    handleResultSelected (result) {
      console.log('接收到搜索结果事件:', result);

      // 将搜索结果事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleResultSelected) {
        this.$refs.gisMap.handleResultSelected(result);
      }
    },

    handleClearSearch () {
      console.log('接收到清除搜索事件');

      // 将清除搜索事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleClearSearch) {
        this.$refs.gisMap.handleClearSearch();
      }
    },

    handleToolClick (key) {
      console.log('接收到工具点击事件:', key);

      // 将工具点击事件传递给 GisMap
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolClick) {
        this.$refs.gisMap.handleToolClick(key);
        // 同步工具容器状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 监听工具容器状态
    watchToolContainer () {
      // 使用 setInterval 轮询检查状态（因为 watch 可能无法监听到深层属性）
      this.toolContainerTimer = setInterval(() => {
        this.updateToolContainerState();
      }, 100);
    },

    // 更新工具容器状态
    updateToolContainerState () {
      if (this.$refs.gisMap) {
        this.toolContainerVisible = this.$refs.gisMap.showToolContainer || false;
        this.currentToolList = this.$refs.gisMap.currentToolList || [];
        this.activeToolType = this.$refs.gisMap.activeToolType || null;
      }
    },

    // 处理工具项点击
    handleToolItemClick (item) {
      if (this.$refs.gisMap && this.$refs.gisMap.handleToolItemClick) {
        this.$refs.gisMap.handleToolItemClick(item);
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    // 处理删除工具
    handleDeleteTool () {
      if (this.$refs.gisMap && this.$refs.gisMap.handleDeleteTool) {
        this.$refs.gisMap.handleDeleteTool();
        // 同步状态
        this.$nextTick(() => {
          this.updateToolContainerState();
        });
      }
    },

    handleLocationMap (locationData) {
      console.log('接收到地图定位事件:', locationData);

      // 调用 GisMap 的定位方法
      if (this.$refs.gisMap && this.$refs.gisMap.setMapLocation) {
        this.$refs.gisMap.setMapLocation(locationData.longitude, locationData.latitude);
      }
    },

    handleWaterControl (data) {
      console.log('接收到区域停水管控事件:', data);
      console.log('管线ID:', data.pipelineId);

      // 调用 BottomMap 组件打开停水管控抽屉，传递管线ID
      if (this.$refs.bottomMap && this.$refs.bottomMap.openWaterCutOff) {
        this.$refs.bottomMap.openWaterCutOff(data.pipelineId, data.feature);
      }
    },

    // 处理筛选变化事件
    handleFilterChange (data) {
      console.log('筛选变化:', data.filterType, data.activeFilters.includes(data.filterType) ? '激活' : '取消');

      const isActive = data.activeFilters.includes(data.filterType);

      // 筛选配置映射
      const filterConfig = {
        masterValve: {
          show: () => this.getMasterValve(data.responseData?.valves, data.responseData?.classNos),
          clear: () => this.$refs.gisMap?.clearMasterValveLayer()
        },
        affectedValve: {
          show: () => this.getAffectedValve(data.responseData?.valves),
          clear: () => this.$refs.gisMap?.clearAffectedValveLayer()
        },
        interconnectValve: {
          show: () => this.getInterconnectionValve(data.responseData?.valves, data.responseData?.classNos),
          clear: () => this.$refs.gisMap?.clearInterconnectionValveLayer()
        },
        drainValve: {
          show: () => this.getDrainValve(data.responseData?.affectedPipelineList),
          clear: () => this.$refs.gisMap?.clearDrainValveLayer()
        },
        hydrant: {
          show: () => this.getHydrant(data.responseData?.affectedPipelineList),
          clear: () => this.$refs.gisMap?.clearHydrantLayer()
        },
        affectedPipe: {
          show: () => this.getAffectedPipe(data.responseData?.affectedPipelineList),
          clear: () => this.$refs.gisMap?.clearAffectedPipeLayer()
        },
        affectedMeter: {
          show: () => this.getAffectedMeter(data.responseData?.waters),
          clear: () => this.$refs.gisMap?.clearAffectedMeterLayer()
        }
      };

      // 执行对应的操作
      const config = filterConfig[data.filterType];
      if (config) {
        isActive ? config.show() : config.clear();
      }
    },

    // 处理显示受影响用户事件
    handleShowAffectedUsers (data) {
      console.log('接收到显示受影响用户事件:', data);

      if (!data || !data.classNos) {
        console.log('无分类编码数据');
        return;
      }

      // 调用 AffectedUsers 组件的 edit 方法
      if (this.$refs.affectedUsers && this.$refs.affectedUsers.edit) {
        this.$refs.affectedUsers.edit(data.classNos, data.pipelineId, '停水管控', data.linkedWaterEvents || []);
      }
    },

    // 处理清除所有图层事件
    handleClearAllLayers () {
      console.log('接收到清除所有图层事件');

      // 清除所有停水管控相关图层
      if (this.$refs.gisMap) {
        // 清除主控阀门图层
        if (this.$refs.gisMap.clearMasterValveLayer) {
          this.$refs.gisMap.clearMasterValveLayer();
        }
        // 清除受影响阀门图层
        if (this.$refs.gisMap.clearAffectedValveLayer) {
          this.$refs.gisMap.clearAffectedValveLayer();
        }
        // 清除互通阀门图层
        if (this.$refs.gisMap.clearInterconnectionValveLayer) {
          this.$refs.gisMap.clearInterconnectionValveLayer();
        }
        // 清除排水阀图层
        if (this.$refs.gisMap.clearDrainValveLayer) {
          this.$refs.gisMap.clearDrainValveLayer();
        }
        // 清除消防栓图层
        if (this.$refs.gisMap.clearHydrantLayer) {
          this.$refs.gisMap.clearHydrantLayer();
        }
        // 清除受影响管道图层
        if (this.$refs.gisMap.clearAffectedPipeLayer) {
          this.$refs.gisMap.clearAffectedPipeLayer();
        }
        // 清除受影响水表图层
        if (this.$refs.gisMap.clearAffectedMeterLayer) {
          this.$refs.gisMap.clearAffectedMeterLayer();
        }
        // 清除高亮阀门图层
        if (this.$refs.gisMap.clearHighlightValveLayer) {
          this.$refs.gisMap.clearHighlightValveLayer();
        }
        // 清除已选中阀门图层
        if (this.$refs.gisMap.clearSelectedValvesLayer) {
          this.$refs.gisMap.clearSelectedValvesLayer();
        }
      }
    },

    // 处理停水事件切换
    handleWaterEventToggle () {
      console.log('切换停水事件显示状态');
      this.waterEventVisible = !this.waterEventVisible;
    },

    // 关闭停水事件
    handleWaterEventClose () {
      console.log('关闭停水事件');
      this.waterEventVisible = false;
    },

    // 将驼峰命名转换为下划线小写（如 startClassNo -> start_class_no）
    camelToSnake (key) {
      return key.replace(/([A-Z])/g, '_$1').toLowerCase();
    },

    // 递归转换对象 key：驼峰 -> 下划线（保留原值结构）
    normalizeKeysToSnake (value) {
      if (Array.isArray(value)) {
        return value.map(item => this.normalizeKeysToSnake(item));
      }
      if (value && typeof value === 'object') {
        const result = {};
        Object.keys(value).forEach((key) => {
          const snakeKey = this.camelToSnake(key);
          result[snakeKey] = this.normalizeKeysToSnake(value[key]);
        });
        return result;
      }
      return value;
    },

    // 处理停水事件点击
    handleEventClick (event, lineDetail) {
      console.log('点击停水事件:', event, lineDetail);
      if (!lineDetail) {
        this.$message.warning('未查询到关联管线详情');
        return;
      }

      // 自动生成下划线字段，并与原对象合并，兼容两种字段风格
      const snakeLineDetail = this.normalizeKeysToSnake(lineDetail);
      const normalizedLineDetail = {
        ...snakeLineDetail,
        ...lineDetail,
        // clickable 字段依赖这个值
        pipelineClassNo: lineDetail.pipelineClassNo || lineDetail.startClassNo || snakeLineDetail.start_class_no
      };

      // 1) 地图高亮显示管线（与地图点击线同一逻辑）
      if (this.$refs.gisMap && this.$refs.gisMap.clickData) {
        try {
          const geoData = normalizedLineDetail.geoJson ? JSON.parse(normalizedLineDetail.geoJson) : null;
          if (geoData && geoData.type === 'LineString') {
            // 先移动并放大到管线中心，再执行高亮
            if (this.$refs.gisMap.setMapLocation && Array.isArray(geoData.coordinates) && geoData.coordinates.length) {
              const first = geoData.coordinates[0];
              const last = geoData.coordinates[geoData.coordinates.length - 1] || first;
              const centerLon = (Number(first[0]) + Number(last[0])) / 2;
              const centerLat = (Number(first[1]) + Number(last[1])) / 2;
              if (!Number.isNaN(centerLon) && !Number.isNaN(centerLat)) {
                this.$refs.gisMap.setMapLocation(centerLon, centerLat, 18);
              }
            }
            this.$refs.gisMap.clickData({ geometry: geoData });
          } else if (this.$refs.gisMap.showAffectedPipes) {
            // 兜底：异常数据时仍尽量展示
            this.$refs.gisMap.showAffectedPipes([normalizedLineDetail]);
          }
        } catch (e) {
          console.error('解析管线geoJson失败:', e);
          if (this.$refs.gisMap.showAffectedPipes) {
            this.$refs.gisMap.showAffectedPipes([normalizedLineDetail]);
          }
        }
      }

      // 2) 详情面板展示管线信息
      if (this.$refs.infoMap && this.$refs.infoMap.handleFeatureData) {
        const feature = {
          id: `gis_pipe_line.${normalizedLineDetail.id || ''}`,
          properties: normalizedLineDetail
        };
        this.$refs.infoMap.handleFeatureData(feature);
      }
    },
    // 获取主控阀门
    getMasterValve (data, classNos = []) {
      console.log('接收到获取主控阀门事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无阀门数据');
        return [];
      }

      // 找出最高的 valveLevel
      const maxValveLevel = Math.min(...data.map(valve => valve.valveLevel || 0));
      console.log('最高阀门级别:', maxValveLevel);

      // 筛选出具有最高 valveLevel 的所有阀门
      let masterValves = data.filter(valve => valve.valveLevel === maxValveLevel);
      console.log('主控阀门数据:', masterValves);

      // TODO: 调用 GisMap 的方法在地图上显示主控阀门
      if (this.$refs.gisMap && this.$refs.gisMap.showMasterValves) {
        this.$refs.gisMap.showMasterValves(masterValves, classNos);
      }
    },
    // 获取影响阀门
    getAffectedValve (data) {
      console.log('接收到获取影响阀门事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无阀门数据');
        return [];
      }

      // 找出最低级别（主控阀门的级别）
      const maxValveLevel = Math.min(...data.map(valve => valve.valveLevel || 0));

      // 筛选出不是最高级别的所有阀门（受影响阀门）
      const affectedValves = data.filter(valve => valve.valveLevel !== maxValveLevel);
      console.log('影响阀门数据:', affectedValves.length, '个');

      // 调用 GisMap 的方法显示影响阀门
      if (this.$refs.gisMap && this.$refs.gisMap.showAffectedValves) {
        this.$refs.gisMap.showAffectedValves(affectedValves);
      }

    },
    // 获取互通阀门
    async getInterconnectionValve (data, classNos = []) {
      console.log('接收到获取互通阀门事件:', data);
      console.log('传入的classNos:', classNos);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无阀门数据');
        return [];
      }

      // 找出最低级别（主控阀门的级别）
      const maxValveLevel = Math.min(...data.map(valve => valve.valveLevel || 0));
      console.log('最高阀门级别:', maxValveLevel);

      // 筛选出具有最高级别的所有阀门（互通阀门）
      const interconnectionValves = data.filter(valve => valve.valveLevel === maxValveLevel);
      console.log('互通阀门数据:', interconnectionValves.length, '个');

      // 提取 class_no
      let allClassNos = interconnectionValves.map(valve => valve.class_no);

      // 如果传入的 classNos 有值，合并它们的 class_no
      if (classNos && Array.isArray(classNos) && classNos.length > 0) {
        const additionalClassNos = classNos.map(item => item.class_no).filter(Boolean);
        allClassNos = [...new Set([...allClassNos, ...additionalClassNos])]; // 去重
        console.log('合并后的分类编码:', allClassNos);
      } else {
        console.log('互通阀门分类编码:', allClassNos);
      }

      const params = {
        classNos: allClassNos.join(',')
      }
      const res = await this.$http.get(this.interconnectionValveUrl, { params })
      // 调用 GisMap 的方法显示互通阀门
      if (this.$refs.gisMap && this.$refs.gisMap.showInterconnectionValves) {
        this.$refs.gisMap.showInterconnectionValves(res.data);
      }
    },
    // 获取排水阀门
    async getDrainValve (data) {
      console.log('接收到获取排水阀门事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无数据');
        return;
      }

      // 提取 id
      const ids = data.map(item => item.id).filter(Boolean);
      console.log('排水阀门IDs:', ids);

      const res = await this.$http.post(this.listFindAppendageUrl, { appendage: '排水阀', layerIds: ids })

      // 调用 GisMap 的方法显示排水阀门
      if (this.$refs.gisMap && this.$refs.gisMap.showDrainValves) {
        this.$refs.gisMap.showDrainValves(res.data.list);
      }
    },
    // 获取消防栓
    async getHydrant (data) {
      console.log('接收到获取消防栓事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无数据');
        return;
      }

      // 提取 id
      const ids = data.map(item => item.id).filter(Boolean);
      console.log('消防栓IDs:', ids);

      const res = await this.$http.post(this.listFindAppendageUrl, { appendage: '消防栓', layerIds: ids })

      // 调用 GisMap 的方法显示消防栓
      if (this.$refs.gisMap && this.$refs.gisMap.showHydrants) {
        this.$refs.gisMap.showHydrants(res.data.list);
      }
    },
    // 获取受影响管道
    getAffectedPipe (data) {
      console.log('接收到获取受影响管道事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无受影响管道数据');
        return;
      }

      // 调用 GisMap 的方法显示受影响管道
      if (this.$refs.gisMap && this.$refs.gisMap.showAffectedPipes) {
        this.$refs.gisMap.showAffectedPipes(data);
      }
    },
    // 获取受影响水表
    getAffectedMeter (data) {
      console.log('接收到获取受影响水表事件:', data);

      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log('无受影响水表数据');
        return;
      }

      // 调用 GisMap 的方法显示受影响水表
      if (this.$refs.gisMap && this.$refs.gisMap.showAffectedMeters) {
        this.$refs.gisMap.showAffectedMeters(data);
      }
    },

    // 处理展示阀门事件
    handleDisplayValve (record) {
      console.log('接收到展示阀门事件:', record);

      // 调用 GisMap 的方法在地图上高亮显示该阀门
      if (this.$refs.gisMap && this.$refs.gisMap.highlightValve) {
        this.$refs.gisMap.highlightValve(record);
      }
    },

    // 处理取消展示阀门事件
    handleCancelDisplayValve () {
      console.log('接收到取消展示阀门事件');

      // 调用 GisMap 的方法清除高亮显示
      if (this.$refs.gisMap && this.$refs.gisMap.clearHighlightValveLayer) {
        this.$refs.gisMap.clearHighlightValveLayer();
      }
    },

    // 处理更新已选中阀门事件
    handleUpdateSelectedValves (selectedValves) {
      console.log('接收到更新已选中阀门事件:', selectedValves);

      // 调用 GisMap 的方法批量显示已选中阀门
      if (this.$refs.gisMap && this.$refs.gisMap.showSelectedValves) {
        this.$refs.gisMap.showSelectedValves(selectedValves);
      }
    }
  }
}
</script>


<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.scaled-components {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; // 让点击事件穿透到地图
  z-index: 1000;

  // 确保子组件可以接收点击事件
  >* {
    pointer-events: auto;
  }
}

// 响应式断点
@media (max-width: 1920px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1440px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 1024px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 768px) {
  .scaled-components {
    transform-origin: center center;
  }
}

@media (max-width: 480px) {
  .scaled-components {
    transform-origin: center center;
  }
}
</style>